module.exports = __webpack_public_path__ + "media/images/proof_links/apple-0c0e528a1980d271f2eeeb9cda281d09.svg";